module.exports = __webpack_public_path__ + "static/media/zalo.5e664d7d.jpg";